import angular from 'angular';

import service from './shadowSettings.service';
import Listing from '../listing/index';
import Browser from 'cars-ng-browser';



export default angular.module('app.shadowSettings', [
    Listing,
    Browser
])

.service('shadowSettingsService', service)

.name;
